import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { homePath, loginPath } from "../lib/routes";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-void flex items-center justify-center">
        <Loader2 size={20} className="animate-spin text-acid" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={loginPath(location.pathname)} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homePath(location.pathname)} replace />;
  }

  return children;
}
